import { render, staticRenderFns } from "./MyInventory.vue?vue&type=template&id=5da08c1a"
import script from "./MyInventory.vue?vue&type=script&lang=js"
export * from "./MyInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports